import script from "./object_simplePageText.vue?vue&type=script&setup=true&lang=js"
export * from "./object_simplePageText.vue?vue&type=script&setup=true&lang=js"

import "./object_simplePageText.vue?vue&type=style&index=0&id=99f4289c&scoped=true&lang=css"

import exportComponent from "/home/dmytro/Projects/gcs/frontend/homepage/gc-schoenbuch/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-99f4289c"]])

export default __exports__